import { render, staticRenderFns } from "./SignupProxy.vue?vue&type=template&id=77fe051f&scoped=true"
import script from "./SignupProxy.vue?vue&type=script&lang=js"
export * from "./SignupProxy.vue?vue&type=script&lang=js"
import style0 from "./SignupProxy.vue?vue&type=style&index=0&id=77fe051f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe051f",
  null
  
)

export default component.exports